var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-good-table',{attrs:{"pagination-options":{
      enabled: true,
      perPage: 5,
      perPageDropdown: [5, 10],
    },"columns":_vm.columns,"rows":_vm.rows}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }